import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '@shared/services/auth.service';
import { ENVIRONMENT_CONFIG } from '@shared/injection-token/environment-config';
import { EnvironmentConfig } from '@shared/interfaces/environment-config';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  protected readonly environmentConfig: EnvironmentConfig;

  constructor(private authService: AuthService) {
    this.environmentConfig = inject(ENVIRONMENT_CONFIG);
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes(this.environmentConfig.api.url)) {
      const token = this.authService.getToken();
      if (this.authService.isSignIn() && token) {
        request = request.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        });
      }
    }

    return next.handle(request);
  }
}
